import { render, staticRenderFns } from "./ProductSetList.vue?vue&type=template&id=5e0f8f2c"
import script from "./ProductSetList.vue?vue&type=script&lang=js"
export * from "./ProductSetList.vue?vue&type=script&lang=js"
import style0 from "./ProductSetList.vue?vue&type=style&index=0&id=5e0f8f2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports